import { getTemplate } from "../template-helper.js";

const COMPONENT_NAME = "z-icon-picker";

const TEMPLATE_ID = "component-" + COMPONENT_NAME + "-template";
const TEMPLATE_URL = "/static/libs/components/" + COMPONENT_NAME + ".html";
let idInc = 0;
export default function register() {
    return getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template) => {

        class IconComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.init();
            }

            closePopper() {
                this.classList.remove("show");
                this.tooltip.classList.remove("show");

                this.inputSearch.classList.add("d-none");
                this.button.parentElement.classList.remove("input-group-prepend");
            }

            openPopper() {
                this.classList.add("show");
                this.tooltip.classList.add("show");

                this.inputSearch.classList.remove("d-none");
                this.button.parentElement.classList.add("input-group-prepend");
                this.inputSearch.focus();
            }

            init() {
                if (!this.innerHTML) {
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }

                this.doImport();

                this.icon = this.querySelector("i");
                this.button = this.querySelector("button");
                this.tooltip = this.querySelector(".dropdown-menu");
                this.icons = this.querySelector(".iconpicker-icons");
                this.inputSearch = this.querySelector("input");

                this.button.id = "bt_icon_"+(idInc++);
                this.tooltip.setAttribute("aria-labelledby", this.button.id);

                if (this.button.initDone) {
                    return;
                }
                this.button.initDone = true;

                this.inputSearch.addEventListener("keyup", () => {
                    this.currentSearch = this.inputSearch.value;
                    this.renderIcons();
                });

                this.button.addEventListener("click", () => {
                    if (this.classList.contains("show")) {
                        this.closePopper();
                    } else {
                        this.openPopper();
                    }
                });

                // this.inputSearch.onblur = () => {
                //     setTimeout(() => {
                //         this.closePopper();
                //     }, 50);
                // } ;

                this.applyRequired();
                this.applyReadonly();

                if (this.currentValue) {
                    this.value = this.currentValue;
                }

                this.getIcons().then((icons) => {
                    this.allIcons = icons;
                    this.renderIcons();
                });

                this.closePopper();
            }

            renderIcons() {
                this.icons.innerHTML = "";
                for (let icon of this.allIcons) {
                    let shouldDisplay = true;
                    if (this.currentSearch) {
                        shouldDisplay = icon.search.some(w => w.indexOf(this.currentSearch.toLowerCase()) !== -1);
                    }
                    if (shouldDisplay) {
                        const div = document.createElement("DIV");
                        div.innerHTML = `<i class="${icon.icon} fa-fw"></i>`;
                        div.id = icon.icon;
                        this.icons.appendChild(div);
                        div.addEventListener("click", () => {
                            this.value = icon.icon;
                            this.dispatchEvent(new Event('change', { bubbles: true }));
                            this.closePopper();
                        });
                    }
                }
            }


            getIcons() {
                if (window.faIcons) {
                    return Promise.resolve(window.faIcons);
                }
                if (window.faIconsPromise) {
                    return window.faIconsPromise;
                }
                window.faIconsPromise = fetch("/node_modules/@fortawesome/fontawesome-free/metadata/icons.yml").then((response) => {
                    return response.text();
                }).then((iconsYml) => {
                    const linesYml = iconsYml.split("\n");
                    window.faIcons = [];
                    let currentIcon = null;
                    let currentSearch = [];
                    let inTerms = false;
                    let inStyles = false;
                    for (let line of linesYml) {
                        if (!line) { continue; }
                        if (line[0] !== ' ') {
                            currentIcon = line.replace(/:$/, "");
                            currentSearch = null;
                            inTerms = false;
                            inStyles = false;
                        } else if (/^ {2}label:/.test(line)) {
                            currentSearch = [line.split(":")[1].toLowerCase()];
                        } else if (/^ {4}terms:/.test(line)) {
                            inTerms = true;
                        } else if (inTerms && /^ {6}- /.test(line)) {
                            currentSearch.push(line.replace(/^ {6}- /, "").toLowerCase());
                        } else if (/^ {2}styles:/.test(line)) {
                            inTerms = false;
                            inStyles = true;
                        } else if (inStyles && /^ {4}- /.test(line)) {
                            let style = line.replace(/^ {4}- /, "");
                            window.faIcons.push({
                                icon: "fa" + style[0] + " fa-" + currentIcon,
                                search: currentSearch
                            });
                        }
                    }
                    return window.faIcons;
                });
                return window.faIconsPromise;
            }

            doImport() {

                const rootNode = this.getRootNode();
                if (!rootNode || !rootNode.getElementById) { return Promise.resolve(); }
                const styleTag = rootNode.getElementById("style_z_icon_picker");
                if (styleTag) { return; }


                let head = rootNode;
                if (rootNode.head) {
                    head = rootNode.head;
                }

                var sInline = document.createElement('style');
                sInline.id = "style_z_icon_picker_inline";
                sInline.setAttribute('type', 'text/css');
                sInline.appendChild(document.createTextNode(`
                    .icon-picker { max-width: 16.5rem }
                    .iconpicker-tooltip { width: 100%; min-height: 4rem; max-height: 20rem }
                    .iconpicker-component {
                        min-width: 24px;
                        min-height: 24px;
                    }
                    .iconpicker-icons { 
                        display: flex; 
                        flex-wrap: wrap; 
                        max-height: 200px; 
                        overflow: auto; 
                        justify-content: center;
                        padding-top: 5px; 
                        align-items: flex-start;
                    }
                    .iconpicker-icons > div{ 
                        padding: 5px; 
                        border: 1px solid #999; 
                        margin-right: 5px; 
                        font-size: 20px;
                        margin-right: 5px;
                        margin-bottom: 5px;  
                        cursor: pointer;
                    }
                `));
                head.appendChild(sInline);

            }

            get value() {
                if (this.icon) {
                    return this.icon.className;
                } else if (this.currentValue) {
                    return this.currentValue;
                }
                return "";
            }

            set value(value) {
                this.currentValue = value;
                if (this.icon) {
                    this.icon.className = value;
                }
            }

            static get observedAttributes() {
                return ['value', 'readonly'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        if (newValue !== this.currentValue) {
                            this.value = newValue;
                        }
                        break;
                    case 'readonly':
                        this.applyReadonly();
                        break;
                    case 'required':
                        this.applyRequired();
                        break;
                }
            }

            applyRequired() {
                const required = this.hasAttribute("required");
                if (this.input) {
                    if (required) {
                        this.input.setAttribute("required", "required");
                    } else {
                        this.input.removeAttribute("required");
                    }
                }
            }
            applyReadonly() {
                const readonly = this.hasAttribute("readonly");
                if (this.button) {
                    if (readonly) {
                        this.button.disabled = true;
                    } else {
                        this.button.disabled = false;
                    }
                }
            }
        }
        customElements.define(COMPONENT_NAME, IconComponent);
    }).catch((err) => {
        throw err;
    });
}
